import { render, staticRenderFns } from "./ContactTypes.vue?vue&type=template&id=760c55c7&scoped=true"
import script from "./ContactTypes.vue?vue&type=script&lang=js"
export * from "./ContactTypes.vue?vue&type=script&lang=js"
import style0 from "./ContactTypes.vue?vue&type=style&index=0&id=760c55c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760c55c7",
  null
  
)

export default component.exports